import styled from 'styled-components';

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

export default ButtonGroup;
